module.exports = __webpack_public_path__ + "static/media/tasklevel3.38bd16c3.png";